<template>
	<div>
		<b-row>
			<b-col cols="5">
				<b-card no-body>
					<b-tabs card v-model="selectedDay">
						<b-tab :title="`${day.startDate} ${niceTime(day.startTime)}`" v-for="(day, key) in route.days" :key="key">
							<b-row>
								<b-col cols="6">
									<b-alert show variant="light">
										Distance
										<b-badge>{{ dayDistance }}</b-badge>
									</b-alert>
								</b-col>

								<b-col cols="6">
									<b-alert show variant="light">
										Time
										<b-badge>{{ dayTime }}</b-badge>
									</b-alert>
								</b-col>
							</b-row>

							<b-list-group v-model="day.waypoints">
								<b-list-group-item class="flex-column align-items-start" :variant="item.active ? 'primary' : 'light'" v-for="(item, index) in day.waypoints" v-bind:key="index" @mouseenter="wayPointMouseOver(index)" @mouseleave="wayPointMouseOut(index)">
									<div class="d-flex w-100 justify-content-between">
										<h5 class="mb-1">
											<strong>{{ index + 1 }}. {{ item.name }}</strong>

											<span v-html="item.description"></span>
										</h5>

										<h5>
											<h5>
												<b-badge variant="info"
													>{{ niceTime(item.start) }} <span v-if="item.end != item.start"> - {{ niceTime(item.end) }}</span></b-badge
												>
											</h5>
										</h5>
									</div>

									<div class="d-flex w-100 flex-column">
										<small class="p-1">{{ item.address.Address1 }},{{ item.address.Address2 }},{{ item.address.Town }},{{ item.address.County }}, {{ item.address.Postcode }}</small>

										<small class="p-1"
											><span v-if="item.distance > 0">
												Driving distance: <b-badge variant="info">{{ item.distanceText }}</b-badge> Driving time: <b-badge variant="info">{{ item.timeText }}</b-badge></span
											>
										</small>

										<small class="p-1" v-if="item.layOver.seconds > 0"
											>Time assigned: <b-badge variant="info">{{ item.layOver.text }}</b-badge></small
										>
									</div>
								</b-list-group-item>
							</b-list-group>
						</b-tab>
					</b-tabs>
				</b-card>
			</b-col>

			<b-col cols="6">
				<div id="map" class="map"></div>
			</b-col>
		</b-row>

		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import RoutePlanService from '@/api-services/routeplan.service';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import ExtraMarkers from 'leaflet-extra-markers';
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';
import Confirm from '@/components/partials/confirm';

// import shares functions
import { dateFuncs } from '@/globs.js';

var routeLines = [];

function createRoute() {
	return {
		days: [
			{
				startDate: dateFuncs.today(),
				startTime: '09:00',
				waypoints: [],
				locked: false,
				recalc: false,
				totals: {
					distance: 0,
					time: 0
				}
			}
		],
		totals: {
			distance: 0,
			time: 0
		}
	};
}

export default {
	name: 'RoutePlanView',

	components: {
		Confirm
	},

	computed: {
		dayDistance: function () {
			return this.getMiles(this.route.days[this.selectedDay].totals.distance);
		},
		dayTime: function () {
			return this.getHoursMins(this.route.days[this.selectedDay].totals.time);
		},
		totalDistance: function () {
			return this.getMiles(this.route.totals.distance);
		},
		totalTime: function () {
			return this.getHoursMins(this.route.totals.time);
		}
	},
	data() {
		return {
			route: createRoute(),
			selectedDay: 0,
			map: null,
			tileLayer: null,
			layers: []
		};
	},
	created() {},
	mounted() {
		this.fetchRoute();
	},
	methods: {
		fetchRoute() {
			RoutePlanService.get(this.$router.currentRoute.params.id)
				.then((res) => {
					let routeDTO = res.data;

					routeDTO.Data.days.forEach((day) => {
						day.startDate = dateFuncs.humanDateFormat(day.startDate);
					});

					this.route = routeDTO.Data;

					this.initMap();
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		wayPointMouseOver(index, fromMap = false) {
			let day = this.selectedDay;
			if (fromMap) {
				index = this.route.days[day].waypoints.findIndex((obj) => obj.markerId == index);
			}
			let waypoint = this.route.days[day].waypoints[index];
			if (typeof waypoint != 'undefined') {
				let markerId = waypoint.markerId;
				waypoint.active = true;
				if (!fromMap) {
					if (typeof this.map._layers[markerId] != 'undefined') {
						this.map._layers[markerId].openPopup();
					}
				}
			}
		},
		wayPointMouseOut(index, fromMap = false) {
			let day = this.selectedDay;
			if (fromMap) {
				index = this.route.days[day].waypoints.findIndex((obj) => obj.markerId == index);
			}
			let waypoint = this.route.days[day].waypoints[index];
			if (typeof waypoint != 'undefined') {
				let markerId = waypoint.markerId;
				waypoint.active = false;
				if (!fromMap) {
					if (typeof this.map._layers[markerId] != 'undefined') {
						this.map._layers[markerId].closePopup();
					}
				}
			}
		},
		loadRoute() {
			let vm = this;
			//vm.route = JSON.parse(testDayJsonStr);
			vm.route.days.forEach((day, i) => {
				let layer = {
					id: i,
					name: `Day ${i + 1}`,
					active: i == 0 ? true : false,
					features: []
				};
				vm.layers.push(layer);
				let markersArr = [];
				day.waypoints.forEach((waypoint, ii) => {
			
					switch (waypoint.type) {
						// Engineer
						case 1:
							var marker = new L.ExtraMarkers.icon({
								icon: 'fa-number',
								markerColor: 'green-light',
								shape: 'circle',
								number: ii + 1
							});
							var popUpHtml =
								'<b-card><h4>' +
								waypoint.name +
								'</h4>' +
							
								'<p>' +
								dateFuncs.humanDateFormat(waypoint.scheduled) +
								'</p>' +
								this.withBr(waypoint.address.Address1) +
								this.withBr(waypoint.address.Address2) +
								this.withBr(waypoint.address.Town) +
								this.withBr(waypoint.address.County) +
								this.withBr(waypoint.address.Postcode) +
								this.withBr(waypoint.address.What3Words) +
								'</b-card>';
							break;
						case 2:
							// clock/ job
							var marker = new L.ExtraMarkers.icon({
								icon: 'fa-number',
								markerColor: 'blue',
								shape: 'circle',
								number: ii + 1
							});
							var popUpHtml =
								'<b-card><h4>' +
								waypoint.name +
								'</h4>' +
								
								'<p>' +
								dateFuncs.humanDateFormat(waypoint.scheduled) +
								'</p>' +
								this.withBr(waypoint.address.Address1) +
								this.withBr(waypoint.address.Address2) +
								this.withBr(waypoint.address.Town) +
								this.withBr(waypoint.address.County) +
								this.withBr(waypoint.address.Postcode) +
								this.withBr(waypoint.address.What3Words) +
								'</b-card>';
							break;

						case 3:
							// stopover
							var marker = new L.ExtraMarkers.icon({
								icon: 'fa-number',
								markerColor: 'orange',
								shape: 'penta',
								number: ii + 1
							});
							var popUpHtml =
								'<b-card><h4>' +
								waypoint.name +
								'</h4>' +
								
								'<p>' +
								dateFuncs.humanDateFormat(waypoint.scheduled) +
								'</p>' +
								this.withBr(waypoint.address.Address1) +
								this.withBr(waypoint.address.Address2) +
								this.withBr(waypoint.address.Town) +
								this.withBr(waypoint.address.County) +
								this.withBr(waypoint.address.Postcode) +
								this.withBr(waypoint.address.What3Words) +
								'</b-card>';
							break;
						case 4:
														/*
							...colours based on their date
							- green: 4 weeks before date
							- orange: 0-4 weeks after date
							- red:  over >4 weeks after date
							*/
							
							var diff = dateFuncs.getDifference(waypoint.scheduled);
							
							let colour = 'blue';

							switch (true) {
								case diff > 0 && diff <= 4:
									colour = 'green';
									break;

								case diff < 0 && diff >= -4:
									colour = 'orange';
									break;

								case diff < -4:
									colour = 'red';
									break;
							}

							var marker = new L.ExtraMarkers.icon({
								icon: 'fa-number',
								markerColor: colour,
								shape: 'star',
								number: ii + 1
							});

							var popUpHtml =
								'<b-card><h4>' +
								waypoint.name +
								'</h4>' +
								
								'<p>' +
								dateFuncs.humanDateFormat(waypoint.scheduled) +
								'</p>' +
								this.withBr(waypoint.address.Address1) +
								this.withBr(waypoint.address.Address2) +
								this.withBr(waypoint.address.Town) +
								this.withBr(waypoint.address.County) +
								this.withBr(waypoint.address.Postcode) +
								this.withBr(waypoint.address.What3Words) +
								'</b-card>';

							break;

						default:
							// just in case something wasn't defined when making the json
							var marker = new L.ExtraMarkers.icon({
								icon: 'fa-number',
								markerColor: 'red',
								shape: 'circle',
								number: ii + 1
							});
							var popUpHtml =
								'<b-card><h4>' +
								waypoint.name +
								'</h4>' +
								
								'<p>' +
								dateFuncs.humanDateFormat(waypoint.scheduled) +
								'</p>' +
								this.withBr(waypoint.address.Address1) +
								this.withBr(waypoint.address.Address2) +
								this.withBr(waypoint.address.Town) +
								this.withBr(waypoint.address.County) +
								this.withBr(waypoint.address.Postcode) +
								this.withBr(waypoint.address.What3Words) +
								'</b-card>';
					}
					var marker = L.marker([waypoint.address.Latitude, waypoint.address.Longitude], {
						icon: marker
					}).bindPopup(popUpHtml);
					// use our own marker id so it never freakin' changes man.
					let uniqueMarkerId = waypoint.markerId + '_' + i;
					waypoint.markerId = uniqueMarkerId;
					marker._leaflet_id = uniqueMarkerId;
					marker.on('mouseover', function () {
						this.openPopup();
						vm.wayPointMouseOver(uniqueMarkerId, true);
					});
					marker.on('mouseout', function () {
						this.closePopup();
						vm.wayPointMouseOut(uniqueMarkerId, true);
					});
					markersArr.push(marker);
				});
				// store locally to hide/show
				let markerLayer = L.featureGroup(markersArr);
				//let markerLayer = new L.layerGroup(markersArr);
				layer.features = markerLayer;
				if (layer.active) {
					vm.map.addLayer(markerLayer);
					vm.map.fitBounds(markerLayer.getBounds());
				}
			});
			vm.drawLines();
		},
		drawLines() {
			if (routeLines.length > 0) {
				for (var i = 0; i < routeLines.length; i++) {
					this.map.removeLayer(routeLines[i]);
				}
				routeLines = [];
			}
			let day = this.selectedDay;
			let lineColour = day % 2 == 0 ? 'red' : 'blue';
			this.route.days[day].waypoints.forEach((thisWaypoint, i) => {
				if (i > 0) {
					let prevWaypoint = this.route.days[day].waypoints[i - 1];
					let origin = L.latLng(prevWaypoint.address.Latitude, prevWaypoint.address.Longitude);
					let dest = L.latLng(thisWaypoint.address.Latitude, thisWaypoint.address.Longitude);
					let mapLine = L.polyline([origin, dest], {
						color: lineColour
					}).addTo(this.map);
					routeLines.push(mapLine);
				}
			});
		},
		initMap() {
			// set map centre and zoom
			this.map = L.map('map').setView([53.019808, -1.642562], 6);
			// set map background tiles
			this.tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
				attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy;'
			});
			// add the tile layer to the map
			this.tileLayer.addTo(this.map);
			this.loadRoute();
		},
		showLayer(layerId) {
			let vm = this;
			vm.layers.forEach((layer, i) => {
				if (layer.id === layerId) {
					if (!vm.map.hasLayer(layer.features)) {
						vm.map.addLayer(layer.features);
						vm.map.fitBounds(layer.features.getBounds());
					}
				} else {
					if (vm.map.hasLayer(layer.features)) {
						vm.map.removeLayer(layer.features);
					}
				}
			});
		},
		// helper functions
		niceTime(time) {
			return dateFuncs.getTime(time);
		},

		getMiles(i) {
			return (i * 0.000621371192).toFixed(2) + ' mi';
		},

		getHoursMins(d) {
			d = Number(d);
			var h = Math.floor(d / 3600);
			var m = Math.floor((d % 3600) / 60);
			var hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : ' 0 hours ';
			var mDisplay = m > 0 ? m + (m == 1 ? ' min' : ' mins') : ' 0 mins';
			return hDisplay + mDisplay;
		},

		withBr(str) {
			return !str || 0 === str.length ? '' : str + '</br>';
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	},
	watch: {
		//
		selectedDay: function (day) {
			this.$nextTick(() => {
				// do we have a previous day?
				this.showLayer(day);
				this.drawLines();
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/routeplan/routeplan-view.vue